import axios from '@utils/axiosInstance'
import sortOptionsByKey from '@utils/sortOptionsByKey'

import { utilsService } from '@/services/utils.service'

const BASE = process.env.VUE_APP_BACKEND_PUBLIC_URL
const getDefaultState = () => {
  return {
    sites: null,
    sitesAll: null,
    teams: [],
    hrRegions: [],
    patrons: [],
    legalRepresentatives: [],
    holidayTypes: [],
    holidays: [],
    ephemeris: [],
    holidayOrEphemeris: null,
    timeZone: {
      name: 'America/Mexico_City',
    },
    siteYearHoliday: {},
  }
}
export const state = getDefaultState()

export const getters = {}

export const mutations = {
  UPDATE_SITES_FOR_MAP(state, sites) {
    state.sites = sites
  },
  UPDATE_SITES(state, sites) {
    if (sites.length > 0) {
      sortOptionsByKey(sites, 'name')
    }
    state.sites = sites
  },
  UPDATE_TEAMS(state, teams) {
    state.teams = teams
  },
  UPDATE_HR_REGIONS(state, hrRegions) {
    state.hrRegions = hrRegions
  },
  UPDATE_PATRONS(state, patrons) {
    state.patrons = patrons
  },
  UPDATE_LEGAL_REPRESENTATIVES(state, collaborators) {
    state.legalRepresentatives = collaborators
  },
  UPDATE_HOLIDAY_TYPES(state, holidayTypes) {
    state.holidayTypes = holidayTypes
  },
  UPDATE_YEAR_HOLIDAYS(state, holidays) {
    state.holidays = holidays
  },
  UPDATE_YEAR_HOLIDAY(state, siteYearHoliday) {
    state.siteYearHoliday = siteYearHoliday
  },
  UPDATE_EPHEMERIS(state, ephemeris) {
    state.ephemeris = ephemeris
  },
  UPDATE_HOLIDAY_OR_EPHEMERIS(state, holidayOrEphemeris) {
    state.holidayOrEphemeris = holidayOrEphemeris
  },
  RESET_SITE_STATE(state) {
    Object.assign(state, getDefaultState())
  },
}

export const actions = {
  // GET
  async fetchSitesForMapAction(store, filters = {}) {
    try {
      store.commit('UPDATE_SITES', [])
      const filtersArr = joinFilters(filters)
      const queryParams = filtersArr.length > 0 ? '?' + filtersArr.join('&') : ''

      const res = await axios.get(`${BASE}/mx/api/v2/sites/maplist${queryParams}`)
      store.commit('UPDATE_SITES', res.data)
    } catch (error) {
      throw new Error(`API Error occurred. ${BASE}/mx/api/v2/sites/maplist ${error}`)
    }
  },
  // SITES
  // GET
  // async fetchSitesForMap(store) {
  //   try {
  //     const res = await axios.get(`${BASE}/api/cms/stores/all`)
  //     store.commit('UPDATE_SITES_FOR_MAP', res.data.result)
  //     return res
  //   } catch (error) {
  //     throw new Error(`API Error occurred. ${BASE}/api/cms/stores/all ${error}`)
  //   }
  // },
  // GET SITES ALL
  // GET
  async fetchSites(store) {
    try {
      const res = await axios.get(`${BASE}/api/v2/sites`)
      store.commit('UPDATE_SITES', res.data)
    } catch (error) {
      throw new Error(`API Error occurred. ${BASE}/api/v2/sites ${error}`)
    }
  },
  // TEAMS
  async fetchTeamsAction({ commit }, filters) {
    const { store, isTemplate = false } = filters
    const { data } = await utilsService.fetchTeamsByStore(store, isTemplate)
    commit('UPDATE_TEAMS', data)
  },
  // GET TEAM PATRON/S
  // GET
  async fetchTeamPatronsAction(store, teamId) {
    try {
      const res = await axios.get(`${BASE}/mx/api/v2/teams/${teamId}/patrons`)
      store.commit('UPDATE_PATRONS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred. ${BASE}/api/v2/teams/${teamId}/patrons`)
    }
  },
  // GET HR REGIONS
  // GET
  async fetchHrRegions(store) {
    try {
      const res = await axios.get(`${BASE}/api/v2/hrRegions`)
      store.commit('UPDATE_HR_REGIONS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred. ${BASE}/api/v2/hrRegion`)
    }
  },
  // RESPONSIBLE PATRON
  // GET
  async fetchResponsiblePatron(store, siteId) {
    try {
      const res = await axios.get(`${BASE}/api/v2/sites/${siteId}/directors`)
      store.commit('UPDATE_PATRONS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${BASE}/api/v2/sites/${siteId}/directors ${error}`)
    }
  },
  // DIRECTOR PATRON
  // GET
  async fetchDirectorPatron(store) {
    try {
      const res = await axios.get(`${BASE}/mx/api/v2/collaborators/countryLeader`)
      store.commit('UPDATE_PATRONS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${BASE}/mx/api/v2/collaborators/countryLeader ${error}`)
    }
  },
  // HOLIDAY TYPES
  // GET
  async fetchHolidayTypesAction(store) {
    try {
      const res = await axios.get(`${BASE}/mx/api/v2/calendar/holidayTypes`)
      store.commit('UPDATE_HOLIDAY_TYPES', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in /mx/api/v2/calendar/holidayTypes: ${error}`)
    }
  },

  // SITE YEAR EPHEMERIS
  // GET
  async fetchEphemeris(store, filters) {
    store.commit('UPDATE_EPHEMERIS', [])
    const { personnelDivision, year } = filters
    try {
      const res = await axios.get(`${BASE}/mx/api/v2/calendar/ephemeris?filter[personnelDivision]=${personnelDivision}&filter[year]=${year}`)
      store.commit('UPDATE_EPHEMERIS', res.data)
    } catch (error) {
      throw new Error(
        `API Error occurred in ${BASE}/mx/api/v2/calendar/ephemeris?filter[personnelDivision]=${personnelDivision}&filter[year]=${year}: ${error}`,
      )
    }
  },
  // SITE YEAR HOLIDAY
  // GET
  async fetchHolidayByUuid(store, uuid) {
    try {
      store.commit('UPDATE_HOLIDAY_OR_EPHEMERIS', null)
      const res = await axios.get(`${BASE}/mx/api/v2/calendar/holiday/${uuid}`)
      store.commit('UPDATE_HOLIDAY_OR_EPHEMERIS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${BASE}/mx/api/v2/calendar/holiday/${uuid}: ${error}`)
    }
  },
  // EPHEMERIS BY UUID
  // GET
  async fetchEphemerisByUuid(store, uuid) {
    try {
      store.commit('UPDATE_HOLIDAY_OR_EPHEMERIS', null)
      const res = await axios.get(`${BASE}/mx/api/v2/calendar/ephemeris/${uuid}`)
      store.commit('UPDATE_HOLIDAY_OR_EPHEMERIS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${BASE}/mx/api/v2/calendar/ephemeris/${uuid}: ${error}`)
    }
  },

  // SITE YEAR HOLIDAYS
  // GET
  async fetchHolidays(store, filters) {
    const filtersArr = []
    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        filtersArr.push(`filter[${key}]=${filters[key]}`)
      }
    })
    const queryString = filtersArr.length > 0 ? '?' + filtersArr.join('&') : ''
    try {
      const res = await axios.get(`${BASE}/mx/api/v2/calendar/holiday${queryString}`)
      store.commit('UPDATE_YEAR_HOLIDAYS', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${BASE}/mx/api/v2/calendar/holiday: ${error}`)
    }
  },
  // SITE YEAR HOLIDAYS
  // GET
  async fetchSiteYearHoliday(store, id) {
    try {
      const res = await axios.get(`${BASE}/mx/api/v2/calendar/holiday/${id}`)
      store.commit('UPDATE_YEAR_HOLIDAY', res.data)
      return res.data
    } catch (error) {
      throw new Error(`API Error occurred in ${BASE}/mx/api/v2/calendar/holiday/${id}: ${error}`)
    }
  },
  // GET SITE LEGAL REPRESENTATIVES
  // GET
  async fetchSiteLegalRepresentatives(store, personnelDivision) {
    const url = `${BASE}/mx/api/v2/sites/${personnelDivision}/legalRepresentatives`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_LEGAL_REPRESENTATIVES', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}`)
    }
  },

  // ///////
  // POST
  // //////

  // HOLIDAY CREATE
  // POST
  async holidayCreateAction(store, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/calendar/holiday.create`, payload)
    } catch (error) {
      throw new Error(`Api error occurred in ${BASE}/mx/api/v2/calendar/holiday.create : ${error}`)
    }
  },
  // HOLIDAY UPDATE
  // POST
  async holidayUpdateAction(store, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/calendar/holiday.update`, payload)
    } catch (error) {
      throw new Error(`Api error occurred in ${BASE}/mx/api/v2/calendar/holiday.update: ${error}`)
    }
  },
  // HOLIDAY DELETE
  // POST
  async holidayDeleteAction(store, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/calendar/holiday.delete`, payload)
    } catch (e) {
      throw Error(`API Error occurred at /mx/api/v2/calendar/holiday.delete`)
    }
  },
  // EPHEMERIS CREATE
  // POST
  async ephemerisCreateAction(store, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/calendar/ephemeris.create`, payload)
    } catch (error) {
      throw new Error(`Api error occurred in ${BASE}/mx/api/v2/calendar/ephemeris.create : ${error}`)
    }
  },
  // EPHEMERIS UPDATE
  // POST
  async ephemerisUpdateAction(store, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/calendar/ephemeris.update`, payload)
    } catch (error) {
      throw new Error(`Api error occurred in ${BASE}/mx/api/v2/calendar/ephemeris.update: ${error}`)
    }
  },
  // EPHEMERIS DELETE
  // POST
  async ephemerisDeleteAction(store, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/calendar/ephemeris.delete`, payload)
    } catch (e) {
      throw Error(`API Error occurred at /mx/api/v2/calendar/ephemeris.delete`)
    }
  },
}

function joinFilters(filters) {
  const filtersArr = []
  Object.keys(filters).forEach((key) => {
    if (filters[key] !== null || filters[key] !== undefined) {
      filtersArr.push(`filter[${key}]=${filters[key]}`)
    }
  })
  return filtersArr
}
